import { createContext, useContext } from 'react'
import { ScreenType } from '../renderers/rendererLocator'

interface IScreenTypeContext {
    screenType: ScreenType
    openDisclosure?: boolean
    stickyHeaders?: boolean
}

const ScreenTypeContext = createContext<IScreenTypeContext>({
    screenType: 'personal',
})
interface IScreenTypeProps {
    children: React.ReactNode
    screenType: ScreenType
    openDisclosure?: boolean
    stickyHeaders?: boolean
}
export const ScreenTypeProvider = (props: IScreenTypeProps) => {
    return (
        <ScreenTypeContext.Provider
            value={{
                screenType: props.screenType,
                openDisclosure: props.openDisclosure,
                stickyHeaders: props.stickyHeaders ?? true,
            }}
        >
            {props.children}
        </ScreenTypeContext.Provider>
    )
}
export const useScreenTypeContext = () => {
    return useContext(ScreenTypeContext)
}
